import { type ReactNode } from 'react';
import styles from './OnboardingLayout.module.css';

interface OnboardingLayoutProps {
  children: ReactNode;
}

interface OnboardingHeaderProps {
  children: ReactNode;
}

interface OnboardingBody {
  children: ReactNode;
}

const OnboardingLayout = ({ children }: OnboardingLayoutProps) => {
  return <div className={styles.layout}>{children}</div>;
};

const OnboardingHeader = ({ children }: OnboardingHeaderProps) => {
  return <div className={styles.header}>{children}</div>;
};

const OnboardingBody = ({ children }: OnboardingBody) => {
  return (
    <div className={styles.body}>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

OnboardingLayout.Header = OnboardingHeader;
OnboardingLayout.Body = OnboardingBody;
export default OnboardingLayout;
